import { Row, Col, Card, Button, Tag, Descriptions } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import MaintenanceForm from "./AddForm";
import moment from "moment";

function Index() {
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState(null);
  const [refresh, setRefresh] = useState(false);

  // -------- FETCH MAINTENANCE CONFIG -------
  const fetchMaintenance = () => {
    setLoading(true);

    request({
      url: apiPath.listMaintenance,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setData(data?.data || null);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchMaintenance();
  }, [refresh]);

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Maintenance Mode"
              extra={
                <Button type="primary" onClick={() => setVisible(true)}>
                  Configure
                </Button>
              }
              loading={loading}
            >
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Status">
                  <Tag color={data?.isEnabled ? "green" : "red"}>
                    {data?.isEnabled ? "Enabled" : "Disabled"}
                  </Tag>
                </Descriptions.Item>

                <Descriptions.Item label="Message">
                  {data?.message || "-"}
                </Descriptions.Item>

                <Descriptions.Item label="Start Time">
                  {data?.startAt
                    ? moment(data.startAt).format("DD-MM-YYYY HH:mm")
                    : "Not Scheduled"}
                </Descriptions.Item>

                <Descriptions.Item label="End Time">
                  {data?.endAt
                    ? moment(data.endAt).format("DD-MM-YYYY HH:mm")
                    : "Not Scheduled"}
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
        </Row>
      </div>

      {visible && (
        <MaintenanceForm
          show={visible}
          hide={() => setVisible(false)}
          data={data}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

export default Index;
